export class NoDistributorsFoundError extends Error {}

export const isNoDistributorsFoundError = (e: unknown) =>
  e instanceof NoDistributorsFoundError;
